import { markRaw } from 'vue'
import type { Component } from 'vue'
import type { TWidgetType } from '@team-milva/lab-models/widget'
import { t } from '@/locales'
import IconLucideLayoutGrid from '~icons/lucide/layout-grid'
import IconLucideCalendarClock from '~icons/lucide/calendar-clock'
import IconLucideHistory from '~icons/lucide/history'
import IconLucideTruck from '~icons/lucide/truck'
import IconLucideFlaskConical from '~icons/lucide/flask-conical'
import IconLucideMapPin from '~icons/lucide/map-pin'
import IconLucideLineChart from '~icons/lucide/line-chart'
import IconLucideUsers from '~icons/lucide/users'

export function getWidgetTypeLabel(type: TWidgetType): string {
  const labels: Record<TWidgetType, string> = {
    'total-overview': t('W: Total oversigt'),
    'daily-overview': t('W: Dagens oversigt'),
    'my-recent-activity': t('W: Min seneste aktivitet'),
    'urgent-deliveries': t('W: Mest presserende leveringer'),
    'urgent-analyses': t('W: Mest presserende analyser'),
    'active-sample-areas': t('W: Aktive prøveområder'),
    'period-graph': t('W: Graf over periode'),
    'top-customers': t('W: Top kunder'),
  }

  return labels[type]
}

export function getWidgetTypeDescription(type: TWidgetType): string {
  const descriptions: Record<TWidgetType, string> = {
    'total-overview': t('W: KPI-kort: aktive ordrer, leveringer, prøver og analyser klar'),
    'daily-overview': t('W: Dagens prøver, leveringer, analyser og afventende fakturaer'),
    'my-recent-activity': t('W: Din seneste aktivitet på tværs af ordrer'),
    'urgent-deliveries': t('W: De mest presserende leveringer, sorteret efter deadline'),
    'urgent-analyses': t('W: De mest presserende analyser, sorteret efter deadline'),
    'active-sample-areas': t('W: Antal aktive analyser pr. prøveområde'),
    'period-graph': t('W: Ordrer, prøver eller omsætning pr. dag over en valgt periode'),
    'top-customers': t('W: Kunder rangeret efter ordrer, prøver eller omsætning'),
  }

  return descriptions[type]
}

export function getWidgetTypeIcon(type: TWidgetType): Component {
  const icons: Record<TWidgetType, Component> = {
    'total-overview': IconLucideLayoutGrid,
    'daily-overview': IconLucideCalendarClock,
    'my-recent-activity': IconLucideHistory,
    'urgent-deliveries': IconLucideTruck,
    'urgent-analyses': IconLucideFlaskConical,
    'active-sample-areas': IconLucideMapPin,
    'period-graph': IconLucideLineChart,
    'top-customers': IconLucideUsers,
  }

  return markRaw(icons[type])
}
